// auth.ts (or whatever this file is named)
const CryptoJs = require('crypto-js');

// CRA injects REACT_APP_* at build-time. If not set, fall back to a default.
// NOTE: Avoid putting real secrets in the browser. Prefer server-side crypto for sensitive data.
const PASS: string = (process.env.REACT_APP_API_AES_PASS as string | undefined) ?? 'default@optum';

export function session(code:string): Promise<Response> {
    const requestBody = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'code': code })
    };
    return fetch(`./session?redirect_uri=${window.location.origin}${window.location.pathname}`, requestBody);
}

export function loginRedirect() {
    //sanitization
    const hrefEncode= encodeURIComponent(JSON.stringify(window.location.href));
    const sanitizedHref = JSON.parse(decodeURIComponent(hrefEncode));
    window.location.href = `./login?redirect_uri=${sanitizedHref}`;
}

export function logoutUser() {
    if('ohid' === decodeURIComponent(getAuthType())) {
       return fetch(`./secure/logout?auth_type=${decodeURIComponent(getAuthType())}&ohid=true`);
    } else{
        return fetch(`./secure/logout?auth_type=${decodeURIComponent(getAuthType())}`);
    }
}

// --- helpers to avoid crashing on bad inputs ---
function safeCipherText(v: unknown): string | null {
  if (typeof v !== 'string') return null;
  const trimmed = v.trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return null;
  return trimmed;
}

// --- encryption / decryption using passphrase API ---
export function encrypt(text: string) {
  const t = text ?? '';
  // PASS is always a non-empty string due to ?? fallback above
return CryptoJs.AES.encrypt(t, PASS).toString();
}

export function decrypt(cipherText: string) {
  const ct = safeCipherText(cipherText);
  if (!ct) return ''; // nothing to decrypt
  const bytes = CryptoJs.AES.decrypt(ct, PASS);
  const plaintext = bytes.toString(CryptoJs.enc.Utf8);
  return plaintext || '';
}

export function setJumpParams(jumpParams){
    sessionStorage.setItem("jumpParams", JSON.stringify(jumpParams));
}

export function getJumpParams(){
    return JSON.parse(sessionStorage.getItem("jumpParams"));
}


// --- sessionStorage accessors with guards ---
export function getSessionId() {
  const raw = sessionStorage.getItem('sessionId');
  return raw ? decrypt(raw) : '';
}

export function setSessionId(sessionId: string) {
  sessionStorage.setItem('sessionId', encrypt(sessionId));
}

export function getAuthType() {
  const raw = sessionStorage.getItem('authType');
  return raw ? decrypt(raw) : '';
}

export function setAuthType(authType: string) {
  sessionStorage.setItem('authType', encrypt(authType));
}

export function getTenantId() {
  const raw = sessionStorage.getItem('tenantId');
  return raw ? decrypt(raw) : '';
}

export function setTenantId(tenantId: string) {
  sessionStorage.setItem('tenantId', encrypt(tenantId));
}